import styled from 'styled-components';

const StyledAppWrapper = styled.div`
  padding-top: ${({ theme, hasNavbar }) => hasNavbar && theme.navbarHeight};
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative; /* for Spinner position */
`;

export default StyledAppWrapper;
